import request from '@/utils/request'
const serivceBase = require('@/config/serviceConfig')

// 兑换码同步兑换（人脸认证）
export function syncVerifyFace(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/syncVerifyFace`,
    method: 'post',
    data
  })
}
// 发送短信人脸验证
export function sendVerifyCodeForFaceSync(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/sendVerifyCodeForFaceSync`,
    method: 'post',
    data
  })
}
// 支付宝实名认证申请认证
export function alipayCertification(data) {
  return request({
    url: `${serivceBase.IMS}/alipayCertification/applyCertification`,
    method: 'post',
    data
  })
}
// 支付宝实名认证查询认证结果
export function queryCertification(data) {
  return request({
    url: `${serivceBase.IMS}/alipayCertification/queryCertification`,
    method: 'post',
    data
  })
}
// 兑换码列表查询
export function listRedeemCodeForSyncLink(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/listRedeemCodeForSyncLink`,
    method: 'post',
    data
  })
}
// 同步链接兑换码-校验接口
export function checkForSyncLink(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/checkForSyncLink`,
    method: 'post',
    data
  })
}
